import { FunctionComponent, ReactNode } from 'react';
import { FiInfo } from 'react-icons/fi';
import { Tooltip, PlacesType } from 'react-tooltip';

interface InfoTooltipProps {
  id: string;
  text: ReactNode;
  className?: string;
  place?: PlacesType;
}

const InfoTooltip: FunctionComponent<InfoTooltipProps> = ({ id, text, className, place }) => {
  return (
    <>
      <a data-tooltip-id={`${id}Tooltip`}>
        <FiInfo className="h-4 w-4" />
      </a>
      <Tooltip id={`${id}Tooltip`} place={place} variant="light" opacity={1} positionStrategy="fixed" className={`z-50 text-center break-words whitespace-normal border-2 border-gray-200 shadow-xl normal-case ${className || 'max-w-[400px]'}`}>
        {text}
      </Tooltip>
    </>
  );
};

export default InfoTooltip;
